import { FC } from "react";

const Home: FC = () => {
  return <div>home</div>;
};
export default Home;
